export default {
  id(state) {
    return state.id;
  },
  userId(state) {
    return state.id;
  },
  username(state) {
    return state.username;
  },
  // Mirrors users.name. For a client this equals their clientName — used
  // by the realtime socket subscription to listen on the client-scoped
  // room and join scopes to their order tagging.
  name(state) {
    return state.name;
  },
  role(state) {
    return state.role;
  },
  vendor(state) {
    return state.vendor;
  },
  payInStatus(state) {
    return state.payInStatus;
  },
  payOutStatus(state) {
    return state.payOutStatus;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  didAutoLogout(state) {
    return state.didAutoLogout;
  },
  isAdmin(state) {
    return state.role == "admin";
  },
  isSubAdmin(state) {
    return state.role == "subadmin";
  },
  isSuperAdmin(state) {
    return state.role == "superadmin";
  },
  isUser(state) {
    return state.role == "user";
  },
  isOrderCreator(state) {
    return state.role == "order_creator";
  },
  isSupport(state) {
    return state.role == "support";
  },
  isClient(state) {
    return state.role == "client";
  },
  // Client Partner (11102026) — view-only role under a vendor that owns a set
  // of clients and sees only their clients' payin/payout + client commission.
  isClientPartner(state) {
    return state.role == "client_partner";
  },
  // Per-branch grant of manual-payin-approval — drives whether the
  // Approve button is shown on payin orders. Backend re-checks the DB
  // on every approval so this is UI-only.
  canApprovePayinManually(state) {
    return !!state.canApprovePayinManually;
  },
  // Per-vendor grant of self-serve client management. Drives sidebar +
  // router; backend re-checks DB on each /clients API call.
  canManageClients(state) {
    return !!state.canManageClients;
  },
  // Partial-payout branch settings (20092026). UI affordance only — the
  // server re-checks fresh on pickup (assignPayoutOrder) and partial
  // approve (approvePayOutOrder). partial-approve defaults ON.
  canPickupPartialPayout(state) {
    return !!state.canPickupPartialPayout;
  },
  canPartialApprovePayout(state) {
    return state.canPartialApprovePayout !== false;
  },
  isSupporting(state) {
    return !!state.isSupporting;
  },
  // Supporting-user effective permission keys (empty for main users).
  effectivePermissions(state) {
    return state.permissions || [];
  },
  // Permission check used by sidebar + router gating. Main users are NEVER
  // permission-gated on the client, so they always pass.
  hasPermission: (state) => (key) => {
    if (!state.isSupporting) return true;
    return (state.permissions || []).includes(key);
  },
  justLoggedIn(state) {
    return !!state.justLoggedIn;
  },
  accessNotice(state) {
    return state.accessNotice;
  },
};
